import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../../services/authentication.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {first} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ProdDialogService} from 'prod-dialog';
import {UserService} from "../../services/user.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  submitted = false;
  loading = false;
  error = '';
  resetPasswordData: {username: string, token: string};

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private dialogService: ProdDialogService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.route.queryParams.subscribe(params => {
      if (params && params['user'] && params['token']) {
        this.resetPasswordData = {username: params['user'], token: params['token']};
      }
      return;
    })
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService.login(this.f['username'].value, this.f['password'].value)
      .pipe(first())
      .subscribe(
        data => {
          this.getAuthenticatedUser(data.token);
        },
        error => {
          this.error = this.translate.instant('login.invalid_credentials');
          this.loading = false;
        });
  }

  getAuthenticatedUser(token) {
    this.authenticationService.getAuthenticatedUser(token)
      .pipe(first())
      .subscribe(
        data => {
          window.location.reload();
        },
        error => {
          this.error = this.translate.instant('login.auth_error');
          this.loading = false;
        });
  }

  onClickForgotPassword() {
    this.dialogService.confirm(this.translate.instant('login.forgot_password.text')).subscribe(closed => {
      if (closed === true) {
        this.userService.forgotPassword(this.f['username'].value)
          .pipe(first())
          .subscribe(res => {
            if (res && res['success']) {
              this.dialogService.alert({
                message: this.translate.instant('login.forgot_password.success_message'),
                title: this.translate.instant('general.success')
              })
            } else {
              this.dialogService.alert({
                message: this.translate.instant('login.forgot_password.error_message'),
                title: this.translate.instant('general.error')
              })
            }
          });
      }
    })
  }
}
